<style lang="scss"></style>

<template>
  <div class="add-app-modal">
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <b-form @submit.stop.prevent="handleSubmit(updateKeyword)">

        <section class="mb-2">
          <validation-provider
            v-slot="validationContext"
            name="Keyword"
            :rules="{ required: true, min: 3 }"
          >
            <label>Keyword</label>
            <b-form-input
              v-model="keyword.keyword" cy="update-keyword-word-input"
              :state="getValidationState(validationContext)" class="mb-1" placeholder="Enter keyword"
            />
            <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
          </validation-provider>

          <validation-provider
            v-slot="validationContext"
            name="Match type"
            :rules="{ required: true }"
          >
            <label>Match Type</label>
            <span id="match-type" style="padding-left: 0.25rem">
              <feather-icon
                icon="InfoIcon"
                size="16"
              />
            </span>
            <b-tooltip
              triggers="hover"
              target="match-type"
            >
              An exact match will trigger only if the exact words are entered, while a partial match will trigger even if part of the phrase is present.
            </b-tooltip>
            <b-form-select
              v-model="keyword.match_type"
              cy="keyword-type-select"
              :state="getValidationState(validationContext)"
              class="mb-2"
            >
              <b-form-select-option value="exact">Exact</b-form-select-option>
              <b-form-select-option value="partial">Partial</b-form-select-option>
            </b-form-select>
            <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
          </validation-provider>
        </section>

        <section class="d-inline-flex full-width mt-2">
          <div class="ui-spacer" />
          <b-button class="mr-2" @click="$emit('close', true)">Cancel</b-button>
          <b-button cy="update-keyword-btn-update" type="submit" variant="primary">Update Keyword</b-button>
        </section>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import { BTooltip } from 'bootstrap-vue';
import KeywordsService from '../../../services/KeywordsService';

export default {
  components: { BTooltip },
  props: {
    existingKeyword: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      keyword: {
        keyword: '',
        matchType: 'exact',
      },
    };
  },
  mounted() {
    this.keyword = { ...this.existingKeyword };
  },
  methods: {
    updateKeyword() {
      // eslint-disable-next-line no-underscore-dangle
      KeywordsService.updateKeyword(this.existingKeyword._id, this.keyword).then(() => {
        this.$toast.success(`Updated keyword to ${this.keyword.keyword} Successfully`, {
          toastClassName: ['toast-std', 'success-toast'],
        });

        this.$emit('refresh', true);
      }).catch(err => {
        console.log('error updating keyword', err);
        this.$toast.error('Could not update keyword, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
};
</script>
